import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import 'react-quill/dist/quill.snow.css';
import { useFormCouponController } from './controller/form';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import { CouponEnum } from '../../enums/couponEnum';
import { CouponModel } from '../../models/coupon';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { MerChantModel } from '../../models/merChantModel';
import AmountComponentPage from './form/amount';
import PercentComponentPage from './form/percent';
import DeliveryFeeComponentPage from './form/deliveryFee';
import DeliveryFeeAmountComponentPage from './form/deliveryFeeAmount';
import DeliveryFeePercentComponentPage from './form/deliveryFeePercent';


interface Props {
  onClose: VoidFunction;
  onFetchData: Function;
  couponData: CouponModel;
  setCoupon: Function;
  branchValue: string;
  selectCouponType: CouponEnum;
  branchData: MerChantModel[];
}

const FormComponent = ({
  onClose,
  onFetchData,
  couponData,
  setCoupon,
  branchValue,
  branchData,
  selectCouponType,
}: Props) => {
  const controller = useFormCouponController({
    dataMerchant: branchData,
    onFetchData,
    onClose,
    couponData,
    setCoupon,
    branchValue,
    selectCouponType,
  });
  const { t } = useTranslation('global');

  const renderForm = () => {
    switch (controller.couponType) {
      case CouponEnum.AMOUNT:
        return (
          <AmountComponentPage
            branchData={branchData}
            couponType={controller.couponType}
            onFetchData={onFetchData}
            onClose={onClose}
          />
        );
      case CouponEnum.PERCENT:
        return (
          <PercentComponentPage
            branchData={branchData}
            couponType={controller.couponType}
            onFetchData={onFetchData}
            onClose={onClose}
          />
        );
      case CouponEnum.DELIVERY_FREE:
        return (
          <DeliveryFeeComponentPage
            branchData={branchData}
            couponType={controller.couponType}
            onFetchData={onFetchData}
            onClose={onClose}
          />
        );
      case CouponEnum.DELIVERY_FEE_AMOUNT:
        return (
          <DeliveryFeeAmountComponentPage
            branchData={branchData}
            couponType={controller.couponType}
            onFetchData={onFetchData}
            onClose={onClose}
          />
        );
        case CouponEnum.DELIVERY_FEE_PERCENT:
          return (
            <DeliveryFeePercentComponentPage
              branchData={branchData}
              couponType={controller.couponType}
              onFetchData={onFetchData}
              onClose={onClose}
            />
          );

      default:
        return null;
    }
  };
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <IconButton
          onClick={() => {
            onClose();
          }}
        >
          <KeyboardBackspaceIcon />
        </IconButton>
        <Box>
          <Typography color={TEXT_TITLE_COLOR} fontWeight="bold" variant="h4" mb={2}>
            {couponData ? t('coupon_page.Update coupon') : t('coupon_page.Create coupon')}
            <Typography color={TEXT_TITLE_COLOR} fontWeight="bold" mt={1}>
              {' '}
              {t('coupon_page.Type')} :{' '}
              <span style={{ color: '#11A2F1' }}>{t('coupon_page.' + controller.couponType)}</span>
            </Typography>
          </Typography>
        </Box>
      </Box>
      {/* Select Coupon Type */}
      <Box sx={{ width: 250 }} mt={1} ml={2}>
        <FormControl fullWidth size="small">
          <InputLabel id="coupon-label-id" shrink={true}>
          {t('coupon_page.Type coupon')}
          </InputLabel>
          <Select
            labelId="coupon-label-id"
            id="coupon-id"
            label="Coupon Type"
            value={controller.couponType}
            onChange={controller.handleSelectCouponType}
          >
            {Object.values(CouponEnum).map((type: CouponEnum) => (
              <MenuItem key={type} value={type}>
                {t('coupon_page.' + type)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      {/* Select Coupon Type */}
      {/* Form */}
      {renderForm()}
      {/* Form */}
    </Box>
  );
};
export default FormComponent;
